import React from 'react';
import PropTypes from 'prop-types';
import { ShowButton, Datagrid, TextField, DateField, Filter, TextInput, SelectInput, DateInput } from 'react-admin';
import AmountField from '../../components/fields/AmountField';
import TList from '../../components/wrapper/TList';
import { toApiDateTimeFormat, toJavaScriptDateFormat } from '../../components/helper/DateHelper';
import { coreWalletBalanceTransactionStatusForSelection } from './BalanceTransactionConstants';
import BalanceTransactionListActions from './BalanceTransactionListActions';

const BalanceTransactionFilter = ({ balanceTransactionStatusForSelection, ...props }) => (
	<Filter {...props}>
		<TextInput
			source="walletId"
			resettable
		/>
		<TextInput
			source="walletAccountId"
			resettable
		/>
		<TextInput
			source="referencedBalanceTransactionId"
			label="resources.balanceTransactions.filter.referencedBalanceTransactionId"
			resettable
		/>
		<TextInput
			source="otherAccountId"
			label="resources.balanceTransactions.filter.otherAccountId"
			resettable
		/>
		<TextInput
			source="otherAccountType"
			label="resources.balanceTransactions.filter.otherAccountType"
			resettable
		/>
		<TextInput
			source="type"
			resettable
		/>
		<TextInput
			source="subType"
			resettable
		/>
		<TextInput
			source="operation"
			resettable
		/>
		<SelectInput
			source="status"
			choices={balanceTransactionStatusForSelection}
		/>
		<TextInput
			source="transactionOwnerId"
			label="resources.balanceTransactions.filter.transactionOwnerId"
			resettable
		/>
		<TextInput
			source="transactionOwnerType"
			label="resources.balanceTransactions.filter.transactionOwnerType"
			resettable
		/>
		<DateInput
			source="fromDate"
			label="resources.balanceTransactions.filter.fromDate"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}

		/>
		<DateInput
			source="untilDate"
			label="resources.balanceTransactions.filter.untilDate"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
	</Filter>
);

const BalanceTransactionList = ({ balanceTransactionStatusForSelection, ...props }) => (
	<TList
		{...props}
		actions={<BalanceTransactionListActions />}
		filters={<BalanceTransactionFilter balanceTransactionStatusForSelection={balanceTransactionStatusForSelection} />}
		sort={{ field: 'id', order: 'DESC' }}
	>
		<Datagrid>
			<ShowButton />
			<TextField source="id" />
			<DateField source="creationDateTime" showTime />
			<AmountField source="amount" sortable={false} />
			<TextField source="status" sortable={false} />
			<TextField source="operation" sortable={false} />
			<TextField source="type" sortable={false} />
			<TextField source="subType" sortable={false} />
			<TextField source="externalId" sortable={false} />
			<TextField source="description" sortable={false} />
		</Datagrid>
	</TList>
);

BalanceTransactionList.propTypes = {
	balanceTransactionStatusForSelection: PropTypes.array.isRequired
};

BalanceTransactionList.defaultProps = {
	balanceTransactionStatusForSelection: coreWalletBalanceTransactionStatusForSelection
};

export default BalanceTransactionList;
